import { ArrowRight } from "lucide-react";
import { Reveal } from "../Reveal";
import { Button } from "../ui/button";
import FeatureArt from "../FeatureArt";
import FeatureOrb, { MORE_ART } from "../FeatureOrb";
import { AUTOMATION_CATEGORIES, SOFTWARE_CATEGORIES } from "../../data/features";
import { SIGNUP_URL } from "../../data/content";

// Same tiles as the homepage product bundle grid (FeatureGrid), so the
// Pricing page shows the exact catalogue a buyer sees on the front page.
export default function PricingToolsGrid() {
  return (
    <section
      data-testid="pricing-tools-grid-section"
      className="relative py-20 md:py-24 border-t border-[#E6E9F1] bg-[#F4F6FB]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-8">
        <Reveal className="max-w-2xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-extrabold tracking-tighter leading-none text-[#0B1533]">
            Every Tool Your Clients Will Pay For
          </h2>
          <p className="mt-4 text-base md:text-lg text-[#475569] leading-relaxed">
            AI automation and QR-based software - all under your logo, your domain, your prices.
          </p>
        </Reveal>

        <Reveal className="mt-14 max-w-2xl mx-auto text-center">
          <h3 className="text-xl md:text-2xl font-extrabold tracking-tighter text-[#0B1533]">Automation Tools</h3>
        </Reveal>
        <div className="mt-8 grid grid-cols-2 gap-x-4 gap-y-10 lg:grid-cols-4 lg:gap-x-8">
          {AUTOMATION_CATEGORIES.map((cat, i) => (
            <Reveal key={cat.id} delay={i * 0.08} className="h-full">
              <FeatureOrb cat={cat} big testId="pricing-tool-card-big" />
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-20 max-w-2xl mx-auto text-center">
          <h3 className="text-xl md:text-2xl font-extrabold tracking-tighter text-[#0B1533]">Included with Powerful Software</h3>
        </Reveal>
        <div className="mt-8 grid grid-cols-2 gap-x-4 gap-y-10 md:grid-cols-3 lg:grid-cols-4 lg:gap-x-8">
          {SOFTWARE_CATEGORIES.map((cat, i) => (
            <Reveal key={cat.id} delay={(i % 4) * 0.06} className="h-full">
              <FeatureOrb cat={cat} testId="pricing-tool-card" />
            </Reveal>
          ))}

          <Reveal delay={(SOFTWARE_CATEGORIES.length % 4) * 0.06} className="h-full">
            <div
              data-testid="pricing-tool-card-coming-soon"
              className="flex h-full flex-col items-center px-2 pb-4 text-center"
            >
              <FeatureArt cat={MORE_ART} className="max-w-[200px]" />
              <h3 className="mt-3 text-sm font-bold leading-snug text-[#0B1533] sm:text-base">
                Many More Products Coming Soon
              </h3>
              <p className="mt-1.5 text-xs font-semibold text-[#FF6B00] sm:text-sm">With No Additional Cost</p>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.15} className="mt-12 text-center">
          <Button
            className="rounded-full h-12 px-8 bg-[#FF6B00] hover:bg-[#FF8533] text-white font-semibold hover:-translate-y-0.5 transition-all"
            asChild
          >
            <a href={SIGNUP_URL}>
              Start Now <ArrowRight className="ml-1.5 w-4 h-4" />
            </a>
          </Button>
        </Reveal>
      </div>
    </section>
  );
}
